import "./skip.css";
import { useNavigate } from "react-router-dom";
import useFormUploadOtherDocs from "../Charterer/lib/useFormUploadOtherDocs";
import useFormUploadOtherDocs_v from "../vesselOwner/Libs/useVesselOwnerOtherDoc";
import { AuthContext } from "../Context/AuthContext";
import { useContext } from "react";

const Skip = () => {
  const {  handleSkip, loading, error, success } = useFormUploadOtherDocs();
  const {  handleSkip: handleSkip_v, loading: loading_v, error: error_v, success: success_v } = useFormUploadOtherDocs_v();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (user.role === 'charterer') {
      navigate("/otherdocs");
    } else if (user.role === 'vesselOwner') {
      navigate("/otherdocs_v");
    }
  };

  const handleNoClick = () => {
    if (user.role === 'charterer') {
      handleSkip();
    } else if (user.role === 'vesselOwner') {
      handleSkip_v();
    }
  };

  return (
    <div className="skip-container">
      <div className="card">
        <p>Do you have additional documents to upload?</p>
        <div className="btn-group">
          <button className="btn-no" onClick={handleNoClick} disabled={loading || loading_v}>
            No
          </button>
          <button className="btn-yes" onClick={handleNavigate} disabled={loading || loading_v}>
            Yes
          </button>
        </div>
        {error && <p className="error">{error}</p>}
        {error_v && <p className="error">{error_v}</p>}
        {success && <p className="success">{success}</p>}
        {success_v && <p className="success">{success_v}</p>}
      </div>
    </div>
  );
};

export default Skip;
